{
  "COMPOSE_REDIRECT": {
    "OPENING": "Se deschide o conversație nouă cu {email}…",
    "NO_EMAIL": "Nu a fost furnizată nicio adresă de email. Utilizați ?email=name@example.com",
    "CONTACT_ERROR": "Nu s-a putut găsi contactul pentru {email}."
  },
  "CONVERSATION": {
    "404": "Ne pare rău, nu am putut găsi conversația. Vă rugăm să încercați din nou",
    "IMAGE_RESIZE": {
      "SMALL": "Mic",
      "MEDIUM": "Mediu",
      "LARGE": "Mare",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Afișează mesajele ascunse",
    "SELECT_A_CONVERSATION": "Vă rugăm să selectați o conversație din panoul din stânga",
    "CSAT_REPLY_MESSAGE": "Vă rugăm să evaluați conversația",
    "SWITCH_VIEW_LAYOUT": "Schimbă aspectul",
    "DASHBOARD_APP_TAB_MESSAGES": "Mesaje",
    "UNVERIFIED_SESSION": "Identitatea acestui utilizator nu este verificată",
    "NO_MESSAGE_1": "Uh oh! Se pare că nu există niciun mesaj de la clienți în căsuța poștală.",
    "NO_MESSAGE_2": " pentru a trimite un mesaj către pagina ta!",
    "NO_INBOX_1": "Hola! Se pare că nu ai adăugat încă nici o căsuță poștală.",
    "NO_INBOX_2": " pentru a începe",
    "NO_INBOX_AGENT": "Uh Oh! Se pare că nu faci parte din nici o căsuță de e-mail. Te rugăm să contactezi administratorul",
    "SEARCH_MESSAGES": "Caută mesaje în conversații",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Traducere",
    "EMPTY_STATE": {
      "CMD_BAR": "to open command menu",
      "KEYBOARD_SHORTCUTS": "to view keyboard shortcuts"
    },
    "SEARCH": {
      "TITLE": "Caută mesaje",
      "RESULT_TITLE": "Rezultate căutare",
      "LOADING_MESSAGE": "Ridicarea datelor...",
      "PLACEHOLDER": "Introduceți orice text pentru a căuta mesaje",
      "NO_MATCHING_RESULTS": "Niciun rezultat găsit."
    },
    "TRANSCRIPT": {
      "SHOW": "Afișează transcrierea completă",
      "HIDE": "Ascunde transcrierea completă",
      "DOWNLOAD": "Descarcă transcrierea",
      "COPY": "Copiază transcrierea"
    },
    "INVISIBLE_TO_CUSTOMER": "Invizibil pentru client",
    "SENT_VIA_EMAIL": "Trimis contactului și prin email ({time})",
    "UNREAD_MESSAGES": "Mesaje necitite",
    "UNREAD_MESSAGE": "Mesaj necitit",
    "CLICK_HERE": "Click aici",
    "LOADING_INBOXES": "Încărcare mesaje primite",
    "LOADING_CONVERSATIONS": "Încărcare conversații",
    "CANNOT_REPLY": "Nu poți răspunde din cauza",
    "24_HOURS_WINDOW": "Restricţie fereastră mesaj 24 de ore",
    "API_HOURS_WINDOW": "Puteți răspunde la această conversație doar în termen de {hours} ore",
    "FACEBOOK_CANNOT_REPLY": "Dacă trebuie să continuați această conversație, ",
    "NOT_ASSIGNED_TO_YOU": "Această conversație nu vă este atribuită. Doriți să vă atribuiți această conversație?",
    "ASSIGN_TO_ME": "Atribuie-mi",
    "PENDING_WITH_BOT_BANNER": "Această conversație este gestionată de un bot AI. Dacă doriți să răspundeți, deschideți mai întâi conversația.",
    "INBOX_DELETE_REQUESTED_BANNER": "Acest inbox este marcat pentru ștergere, așa că răspunsul clientului nu ar ajunge niciodată. Mută conversația în alt inbox pentru a răspunde.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Acest contact are o altă conversație deschisă #{id}",
      "MULTIPLE": "Acest contact are alte conversații deschise ({count})",
      "OPEN": "Deschide",
      "SHOW": "Afișează"
    },
    "TWILIO_WHATSAPP_CAN_REPLY": "Poți răspunde la această conversație doar folosind un mesaj șablon datorat",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "Restricţie fereastră mesaj 24 de ore",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "Acest cont Instagram a fost migrat la noul inbox de canal Instagram. Toate mesajele noi vor apărea acolo. Nu veți mai putea trimite mesaje din această conversație.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Nu se poate trimite mesajul deoarece clientul nu este online și continuitatea pe email nu este disponibilă.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "Clientul nu este online. Este posibil să nu primească mesajele deoarece continuitatea pe email nu este disponibilă.",
    "REPLYING_TO": "Răspundeți la:",
    "REMOVE_SELECTION": "Elimină selecția",
    "DOWNLOAD": "Descărcare",
    "OPEN_FILE": "Deschide",
    "DOWNLOAD_ATTACHMENTS": "Descarcă tot",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Descarcă toate atașamentele pe rând",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Descarcă tot ca ZIP",
    "ERROR_DOWNLOADING_FILE": "Eroare la descărcarea fișierului",
    "UNKNOWN_FILE_TYPE": "Fișier necunoscut",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Înainte de trimitere efectuați:",
      "EXECUTE": "Execută",
      "RETRY": "Încercați din nou",
      "CONFIRM": "Executați acum?",
      "CONFIRM_YES": "Da, execută",
      "CONFIRM_NO": "Anulează",
      "RUNNING": "Se execută…",
      "DONE": "Efectuat",
      "CLAIM_DELAYED": "va fi depusă după livrarea comenzii",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "A fost creată o reclamație NOUĂ {reference}, deoarece {planned} este închisă — editați textul ciornei",
        "NEW_CLAIM": "A fost creată o reclamație NOUĂ {reference} în loc să fie actualizată {planned} — editați textul ciornei",
        "OTHER_CLAIM": "A fost actualizată reclamația {reference} în loc de {planned} — editați textul ciornei",
        "EXISTING_CLAIM": "Nu a fost creată o reclamație nouă, a fost actualizată cea existentă {reference} — editați textul ciornei",
        "OTHER": "S-a întâmplat altfel decât presupunea ciorna — editați textul ciornei"
      },
      "FAILED": "Eșuat",
      "UNREACHABLE": "Botul nu este disponibil",
      "REQUEST_FAILED": "Acțiunea nu a putut fi pornită, încercați din nou.",
      "ACTIONS": {
        "CANCEL_ORDER": "Anulați comanda",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Schimbați plata în ramburs",
        "CREATE_CLAIM": "Depuneți o reclamație",
        "CREATE_OR_UPDATE_CLAIM": "Depuneți sau actualizați o reclamație",
        "EXTEND_ORDER_PICKUP_DATE": "Prelungiți termenul de ridicare"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "Se încarcă atașamentele...",
    "REPLIED_TO_STORY": "A răspuns la povestea ta",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "This message is unsupported. You can view this message on the Facebook Messenger app.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "This message is unsupported. You can view this message on the Instagram app.",
    "SUCCESS_DELETE_MESSAGE": "Mesaj şters cu succes",
    "FAIL_DELETE_MESSSAGE": "Mesajul nu a putut fi șters! Încercați din nou",
    "NO_RESPONSE": "Niciun răspuns",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Cereți clientului să partajeze numărul său de telefon WhatsApp",
      "PENDING_ACTION": "Solicitare de informații de contact în așteptare",
      "STATES": {
        "PENDING": "Se așteaptă informațiile de contact",
        "SHARED": "Număr de telefon partajat",
        "IDENTITY_CONFLICT": "Numărul de telefon necesită verificare"
      }
    },
    "RESPONSE": "Response",
    "RATING_TITLE": "Evaluare",
    "FEEDBACK_TITLE": "Păreri",
    "REPLY_MESSAGE_NOT_FOUND": "Message not available",
    "CARD": {
      "SHOW_LABELS": "Afișare etichete",
      "HIDE_LABELS": "Ascunderea etichetelor"
    },
    "HEADER": {
      "MORE": "Mai multe acțiuni",
      "RESOLVE_ACTION": "Rezolvă",
      "REOPEN_ACTION": "Redeschide",
      "OPEN_ACTION": "Deschide",
      "OPEN": "Mai mult",
      "CLOSE": "Închide",
      "DETAILS": "detalii",
      "SNOOZED_UNTIL": "Amânare până la",
      "SNOOZED_UNTIL_TOMORROW": "Amânat până mâine",
      "SNOOZED_UNTIL_NEXT_WEEK": "Amânat până săptămâna viitoare",
      "SNOOZED_UNTIL_NEXT_REPLY": "Amânat până la următorul răspuns",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Marchează ca în așteptare",
      "SNOOZE_UNTIL": "Amânați",
      "RESOLVE_WITHOUT_CSAT": "Rezolvă fără CSAT",
      "SNOOZE": {
        "TITLE": "Amânare până la",
        "NEXT_REPLY": "Următorul răspuns",
        "TOMORROW": "Mâine",
        "NEXT_WEEK": "Săptămâna viitoare"
      }
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Amânare până la",
      "APPLY": "Amânați",
      "CANCEL": "Renunță"
    },
    "PRIORITY": {
      "TITLE": "Prioritate",
      "OPTIONS": {
        "NONE": "Nimic",
        "URGENT": "Urgent",
        "HIGH": "Mare",
        "MEDIUM": "Mediu",
        "LOW": "Scăzut"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Nimic",
        "INPUT_PLACEHOLDER": "Selectați prioritatea",
        "NO_RESULTS": "Niciun rezultat găsit",
        "SUCCESSFUL": "A schimbat prioritatea ID-ului conversației {conversationId} în {priority}",
        "FAILED": "Nu s-a putut schimba prioritatea. Vă rugăm să încercați din nou."
      }
    },
    "SLA": {
      "BREACHED": "încălcat"
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Deschide într-o filă nouă",
      "COPY_LINK": "Copiază linkul conversației",
      "COPY_LINK_SUCCESS": "Linkul conversației a fost copiat în clipboard",
      "PENDING": "Marchează ca în așteptare",
      "RESOLVED": "Marcați ca rezolvat",
      "MARK_AS_UNREAD": "Marcheaza ca necitit",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "Redeschiderea conversației",
      "SNOOZE": {
        "TITLE": "Amânați",
        "NEXT_REPLY": "Până la următorul răspuns",
        "TOMORROW": "Până mâine",
        "NEXT_WEEK": "Până săptămâna viitoare"
      },
      "ASSIGN_AGENT": "Atribuiți agent",
      "ASSIGN_LABEL": "Atribuiți eticheta",
      "AGENTS_LOADING": "Se încarcă agenții...",
      "ASSIGN_TEAM": "Atribuiți echipă",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Id conversație {conversationId} atribuit la \"{agentName}\"",
          "FAILED": "Nu s-a putut atribui agentul. Vă rugăm încercați din nou."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Nu s-a putut atribui eticheta. Vă rugăm încercați din nou."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Echipa atribuită #{team} la conversația cu id {conversationId}",
          "FAILED": "Nu s-a putut atribui echipa. Vă rugăm să încercaţi din nou."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Semnătura mesajului",
      "ENABLE_SIGN_TOOLTIP": "Activarea semnăturii",
      "DISABLE_SIGN_TOOLTIP": "Dezactivarea semnăturii",
      "INSERT_SIGNATURE": "Inserează semnătura în editor",
      "SIGNATURE_PREVIEW_IMAGE": "(semnătură imagine)",
      "MSG_INPUT": "Shift + enter pentru linie nouă. Începe cu '/' pentru a selecta un răspuns predeterminat.",
      "PRIVATE_MSG_INPUT": "Shift + enter pentru linie nouă. Acest lucru va fi vizibil doar pentru Agenți",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Semnătura mesajului nu este configurată, vă rugăm să o configurați în setările profilului.",
      "CLICK_HERE": "Click aici pentru a actualiza",
      "WHATSAPP_TEMPLATES": "Șabloane WhatsApp",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "Fereastra de 24 de ore WhatsApp a expirat. Răspundeți cu un mesaj șablon."
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Răspunsul tău pare să fie în {draftLanguage}, dar această conversație este în {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Traducere",
      "REPLY": "Răspunde",
      "PRIVATE_NOTE": "Notă privată",
      "SEND": "Trimite",
      "SEND_EMAIL": "Trimite email",
      "SEND_SMS": "Trimite SMS",
      "NO_SMS_INBOX": "Adăugați un inbox SMS pentru a trimite răspunsuri prin SMS.",
      "SEND_CHAT": "Trimite chat",
      "CREATE": "Adaugă Notă",
      "INSERT_READ_MORE": "Citeşte mai mult",
      "DISMISS_REPLY": "Dismiss reply",
      "REPLYING_TO": "Replying to:",
      "REPLY_TO_THIS": "Răspunde la acesta",
      "TIP_EXPAND_ICON": "Mărește editorul",
      "TIP_COLLAPSE_ICON": "Micșorează editorul",
      "TIP_FORMAT_ICON": "Arată editorul de text",
      "HEADING_LEVEL": {
        "LABEL": "Stil text",
        "NORMAL": "Text normal",
        "H1": "Titlu 1",
        "H2": "Titlu 2",
        "H3": "Titlu 3"
      },
      "EDITOR": {
        "BOLD": "Aldin",
        "ITALIC": "Cursiv",
        "UNDERLINE": "Subliniat",
        "TEXT_COLOR": "Culoarea textului",
        "BG_COLOR_LABEL": "Culoare de fundal",
        "FONT_SIZE_LABEL": "Dimensiune font",
        "FONT_SIZE": {
          "XS": "Mic",
          "SM": "Mediu-mic",
          "MD": "Implicit",
          "LG": "Mare",
          "XL": "Foarte mare",
          "XXL": "Uriaș"
        },
        "CODE": "Cod",
        "LINK": "Adaugă sau elimină linkul",
        "CREATE_LINK": "Creează un link",
        "SAVE_LINK": "Salvează",
        "CANCEL": "Renunță",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Anulează",
        "REDO": "Refă",
        "BULLET_LIST": "Listă cu marcatori",
        "ORDERED_LIST": "Listă numerotată",
        "BLOCKQUOTE": "Citat",
        "H1": "Titlu 1",
        "H2": "Titlu 2",
        "H3": "Titlu 3",
        "IMAGE_UPLOAD": "Încarcă imagine",
        "CLEAR_FORMATTING": "Elimină formatarea",
        "COLOR": {
          "RED": "Roșu",
          "YELLOW": "Galben",
          "BLUE": "Albastru",
          "ROSE_RED": "Roșu-roz",
          "DEEP_CYAN": "Cyan închis",
          "ORANGE": "Portocaliu",
          "PISTACHIO": "Fistic",
          "PURPLE": "Mov",
          "FUCHSIA": "Fucsia",
          "SILVER": "Argintiu",
          "NAVY": "Bleumarin",
          "OLD_PINK": "Roz vechi",
          "AQUA": "Turcoaz",
          "BROWN": "Maro",
          "OLIVE": "Verde-oliv",
          "GOLD": "Auriu",
          "BEIGE": "Bej",
          "WINE": "Vișiniu",
          "FOREST": "Verde-pădure",
          "GREEN": "Verde",
          "BLUE_GREY": "Gri-albăstrui",
          "RUBY_RED": "Roșu-rubiniu",
          "CHESTNUT_BROWN": "Maro-castaniu",
          "ASH_GREY": "Gri-cenușiu"
        },
        "BG_COLOR": {
          "RED": "Roșu",
          "YELLOW": "Galben",
          "BLUE": "Albastru",
          "ROSE_RED": "Roșu-roz",
          "DEEP_CYAN": "Cyan închis",
          "ORANGE": "Portocaliu",
          "PISTACHIO": "Fistic",
          "PURPLE": "Mov",
          "FUCHSIA": "Fucsia",
          "SILVER": "Argintiu",
          "NAVY": "Bleumarin",
          "OLD_PINK": "Roz vechi",
          "AQUA": "Turcoaz",
          "BROWN": "Maro",
          "OLIVE": "Verde-oliv",
          "GOLD": "Auriu",
          "BEIGE": "Bej",
          "WINE": "Vișiniu",
          "FOREST": "Verde-pădure",
          "GREEN": "Verde",
          "BLUE_GREY": "Gri-albăstrui",
          "RUBY_RED": "Roșu-rubiniu",
          "CHESTNUT_BROWN": "Maro-castaniu",
          "ASH_GREY": "Gri-cenușiu"
        }
      },
      "TIP_EMOJI_ICON": "Arată selectorul emoji",
      "TIP_ATTACH_ICON": "Ataşează fişiere",
      "TIP_AUDIORECORDER_ICON": "Înregistrare audio",
      "TIP_AUDIORECORDER_PERMISSION": "Permiteți accesul la audio",
      "TIP_AUDIORECORDER_ERROR": "Nu s-a putut deschide audio",
      "DRAG_DROP": "Trageți și plasați aici pentru atașare",
      "START_AUDIO_RECORDING": "Pornirea înregistrării audio",
      "STOP_AUDIO_RECORDING": "Mesaj audio",
      "EMAIL_HEAD": {
        "EDIT": "Editează",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Ascunde",
        "INCLUDE_ORIGINAL_MESSAGE": "Include mesajul original",
        "TO": "TO",
        "ADD_BCC": "Adaugă bcc",
        "EDIT_HEADERS": "Editează",
        "HIDE_HEADER_EDITS": "Ascunde modificările",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "E-mailuri separate prin virgulă",
          "ERROR": "Vă rugăm să introduceți o adresă de e-mail validă"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "E-mailuri separate prin virgulă",
          "ERROR": "Vă rugăm să introduceți o adresă de e-mail validă"
        },
        "SUBJECT": {
          "LABEL": "SUBIECT",
          "PLACEHOLDER": "Subiect email",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Variabile nedefinite",
        "MESSAGE": "Aveți {undefinedVariablesCount} variabile nedefinite în mesajul dvs.: {undefinedVariables}. Doriți să trimiteți mesajul oricum?",
        "CONFIRM": {
          "YES": "Trimite",
          "CANCEL": "Renunță"
        }
      },
      "COPILOT": {
        "Q": "Cere ajutor robotului"
      },
      "": ""
    },
    "VISIBLE_TO_AGENTS": "Notă privată: vizibilă doar pentru tine și echipa ta",
    "CHANGE_STATUS": "Stare conversație schimbată",
    "CHANGE_STATUS_FAILED": "Schimbarea stării conversației a eșuat",
    "CHANGE_AGENT": "Persoana căreia i-a fost ateribuită conversația a fost schimbată",
    "CHANGE_AGENT_FAILED": "Schimbarea agentului a eșuat",
    "ASSIGN_LABEL_SUCCESFUL": "Etichetă atribuită cu succes",
    "ASSIGN_LABEL_FAILED": "Atribuirea etichetei a eșuat",
    "CHANGE_TEAM": "Echipa de conversație schimbată",
    "IMAGE_UPLOAD_ERROR": "Nu s-a putut încărca imaginea, vă rugăm să încercați din nou",
    "FILE_SIZE_LIMIT": "Fișierul depășește limita de {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB",
    "DRAFT": {
      "FILE_TOO_LARGE": "Fișierul „{fileName}” ({fileSize}) este prea mare pentru stocarea în ciornă și va fi omis",
      "ATTACHMENT_SERIALIZATION_FAILED": "Serializarea atașamentului pentru stocarea în ciornă a eșuat",
      "STORAGE_QUOTA_EXCEEDED": "Cota de stocare a fost depășită. Ciorna a fost salvată fără atașamente",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Ciorna nu a putut fi salvată nici măcar fără atașamente",
      "SAVE_FAILED": "Ciorna conversației nu a putut fi salvată"
    },
    "MESSAGE_ERROR": "Mesajul nu poate fi trimis, te rugăm să încerci din nou mai târziu",
    "SENT_BY": "Trimis de:",
    "BOT": "Bot",
    "SEND_FAILED": "Nu a putut trimite mesaj! Încearcă din nou",
    "TRY_AGAIN": "reîncercare",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Selectează agent",
      "REMOVE": "Elimină",
      "ASSIGN": "Atribuiți"
    },
    "CONTEXT_MENU": {
      "COPY": "Copiază",
      "REPLY_TO": "Reply to this message",
      "DELETE": "Şterge",
      "CREATE_A_CANNED_RESPONSE": "Adaugați la răspunsuri predefinite",
      "TRANSLATE": "Traduceți",
      "COPY_PERMALINK": "Copierea linkului la mesaj",
      "LINK_COPIED": "URL-ul mesajului copiat în clipboard",
      "FORWARD": "Redirecționează",
      "FORWARD_ERROR": "Pregătirea mesajului redirecționat a eșuat",
      "DELETE_CONFIRMATION": {
        "TITLE": "Ești sigur că vrei să ștergi acest mesaj?",
        "MESSAGE": "Nu puteți anula această acțiune",
        "DELETE": "Şterge",
        "CANCEL": "Renunță"
      }
    },
    "SIDEBAR": {
      "CONTACT": "Contact",
      "COPILOT": "Copilot"
    },
    "COMMENT_TREE": {
      "TITLE": "Fir de comentarii",
      "EMPTY": "Niciun comentariu de afișat",
      "VIEW_TREE": "Vezi firul de comentarii"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "Conversația a fost marcată de {userName}",
          "CONTACT_RESOLVED": "Conversația a fost rezolvată de {contactName}",
          "OPEN": "Conversația a fost redeschisă de {userName}",
          "PENDING": "Conversația a fost marcată ca fiind în așteptare de către {userName}",
          "SNOOZED": "Conversația a fost snoozed de {userName}",
          "AUTO_RESOLVED": "Conversația a fost marcată de sistem din cauza {duration} zile de inactivitate",
          "SYSTEM_AUTO_OPEN": "Sistemul a redeschis conversația din cauza unui nou mesaj de intrare.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Conversația a fost marcată ca rezolvată de {userName} (fără CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Conversația a fost marcată ca rezolvată de sistem din cauza a {duration} ore de inactivitate",
          "AUTO_RESOLVED_EMPTY": "Conversația a fost marcată ca rezolvată de sistem pentru că era goală.",
          "BLOCKED_CONTACT_RESOLVED": "Sistemul a rezolvat conversația deoarece contactul este blocat.",
          "KAUFLAND_TICKET_CLOSED": "Sistemul a rezolvat conversația deoarece tichetul a fost închis pe Kaufland."
        },
        "PRIORITY": {
          "ADDED": "{userName} setați prioritatea pentru a {newPriority}",
          "UPDATED": "{userName} schimbat prioritatea de la {oldPriority} la {newPriority}",
          "REMOVED": "{userName} eliminat prioritatea"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} auto-atribuit această conversație",
          "ASSIGNED": "Atribuit lui {assigneeName} de {userName}",
          "REMOVED": "Conversație neasociată de {userName}"
        },
        "TEAM": {
          "ASSIGNED": "Atribuit lui {teamName} de {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Atribuit {assigneeName} prin {teamName} de către {userName}",
          "REMOVED": "Neatribuit de la {teamName} de către {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} adăugat {labels}",
          "REMOVED": "{userName} eliminat {labels}"
        },
        "SLA": {
          "ADDED": "{userName} added SLA policy {slaName}",
          "REMOVED": "{userName} removed SLA policy {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} a dezactivat conversația",
        "UNMUTED": "{userName} a activat conversația",
        "CONTACT_BLOCKED": "{userName} a blocat contactul",
        "CONTACT_UNBLOCKED": "{userName} a deblocat contactul",
        "AUTO_RESOLUTION_MESSAGE": "Resolving the conversation as it has been inactive for a while. Please start a new conversation if you need further assistance.",
        "DOMAIN_BLOCKED": "{userName} a blocat toate contactele pentru un domeniu dat",
        "DOMAIN_UNBLOCKED": "{userName} a deblocat toate contactele pentru un domeniu dat",
        "MERGED": "{userName} a combinat conversația #{sourceId} în această conversație",
        "MOVED": "{userName} a mutat această conversație din inboxul {sourceInboxName} în inboxul {targetInboxName}",
        "MOVED_BY_ORDER": "Mutată deoarece comenzile contactului provin doar din magazinul {storeName} (ultima comandă {orderId}), al cărui robot răspunde în acest inbox.",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Acțiunea de trimitere a mesajului a fost omisă pentru acest mesaj de răspuns automat",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Automatizarea a fost omisă deoarece contactul este blocat",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Automatizarea \"{ruleName}\" nu a putut muta această conversație din inboxul {sourceInboxName} în inboxul {targetInboxName}, deoarece inboxurile nu sunt compatibile.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Automatizarea \"{ruleName}\" nu a putut muta această conversație din inboxul {sourceInboxName} în inboxul {targetInboxName}, deoarece contactul nu are o adresă de email.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Automatizarea \"{ruleName}\" nu a putut trimite un mesaj: acest inbox de telefon nu poate trimite SMS, deoarece contul nu are niciun inbox SMS. Regula a fost dezactivată, iar administratorii au primit un email.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Automatizarea \"{ruleName}\" nu a putut trimite un mesaj: atașamentele nu pot fi trimise prin SMS din acest inbox. Regula a fost dezactivată, iar administratorii au primit un email.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Macrocomanda \"{macroName}\" nu și-a trimis mesajul: acest inbox de telefon nu poate trimite SMS, deoarece contul nu are niciun inbox SMS.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Macrocomanda \"{macroName}\" nu și-a trimis mesajul: atașamentele nu pot fi trimise prin SMS din acest inbox.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Macrocomanda \"{macroName}\" nu și-a trimis mesajul: botul gestionează această conversație. Deschide mai întâi conversația.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Macrocomanda \"{macroName}\" nu și-a trimis mesajul: acest inbox este marcat pentru ștergere. Mută mai întâi conversația în alt inbox.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Automatizarea \"{ruleName}\" a trimis un email către {contactEmail} într-o conversație nouă [#{conversationId}]({conversationPath}) în inboxul {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Automatizarea \"{ruleName}\" a început această conversație din cauza conversației [#{conversationId}]({conversationPath}) din inboxul {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Automatizarea \"{ruleName}\" nu a putut trimite mesajul într-o conversație nouă în inboxul {inboxName}, deoarece contactul nu are o adresă de email.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Automatizarea \"{ruleName}\" a trimis un SMS către {contactPhone} într-o conversație nouă [#{conversationId}]({conversationPath}) în inboxul {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Automatizarea \"{ruleName}\" nu a putut trimite SMS-ul într-o conversație nouă în inboxul {inboxName}, deoarece contactul nu are număr de telefon.",
        "AUTOMATION_RULE_TRIGGERED": "Regula de automatizare \"{ruleName}\" a fost declanșată",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Regula de automatizare \"{ruleName}\" a dezactivat prioritatea automată",
        "AUTOMATION_SKIP_AUTO_LABELING": "Regula de automatizare \"{ruleName}\" a dezactivat etichetarea automată",
        "AUTOMATION_STOP_PROCESSING_RULES": "Regula de automatizare \"{ruleName}\" a oprit procesarea ulterioară a regulilor",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Agent",
            "CUSTOMER": "Client"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "răspuns în altă parte, a sunat {duration}",
            "NO_ANSWER": "fără răspuns, a sunat {duration}",
            "REJECTED": "respins după ce a sunat {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Rezolvat automat după reapelări nereușite: {count}",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Înregistrarea apelului a fost ștearsă de {name}, {date}"
        }
      }
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Trimite transcrierea conversației",
    "DESC": "Trimite o copie a transcrisului de conversație la adresa de e-mail specificată",
    "SUBMIT": "Trimite",
    "CANCEL": "Renunță",
    "SEND_EMAIL_SUCCESS": "Transscrisul de chat a fost trimis cu succes",
    "SEND_EMAIL_ERROR": "A apărut o eroare, încercați din nou",
    "FORM": {
      "SEND_TO_CONTACT": "Trimite transcrierea către client",
      "SEND_TO_AGENT": "Trimite transcrierea către agentul atribuit",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Această adresă de e-mail este folosită pentru un alt contact",
      "EMAIL": {
        "PLACEHOLDER": "Introduceți o adresă de e-mail",
        "ERROR": "Vă rugăm să introduceți o adresă de e-mail validă"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Hei 👋, Bine ati venit la {installationName}!",
    "DESCRIPTION": "Vă mulțumim pentru semnarea sus. Vrem să profitați la maximum de {installationName}. Iată câteva lucruri pe care le puteți face în {installationName} pentru a face experiența încântătoare.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Citiți cele mai recente actualizări ale noastre",
    "ALL_CONVERSATION": {
      "TITLE": "Toate conversațiile într-un singur loc",
      "DESCRIPTION": "Vizualizați toate conversațiile de la clienți într-un singur tablou de bord. Puteți filtra conversațiile după canalul, eticheta și starea primite.",
      "NEW_LINK": "Click aici pentru a crea un inbox"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Invită-ți membrii echipei",
      "DESCRIPTION": "Din moment ce vă pregătiți să vorbiți cu clientul dvs., aduceți-vă coechipierii pentru a vă ajuta. Vă puteți invita colegii de echipă adăugând adresele lor de e-mail la lista de agenți.",
      "NEW_LINK": "Faceți clic aici pentru a invita un membru al echipei"
    },
    "LABELS": {
      "TITLE": "Organizarea conversațiilor cu etichete",
      "DESCRIPTION": "Etichetele oferă o modalitate mai ușoară de a clasifica conversația. Creați unele etichete, cum ar fi #support-solicitare, #billing-întrebare etc., astfel încât să le puteți utiliza într-o conversație mai târziu.",
      "NEW_LINK": "Click aici pentru a crea tag-uri"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Agent atribuit",
    "SELF_ASSIGN": "Atribuie-mi",
    "TEAM_LABEL": "Echipa desemnată",
    "SELECT": {
      "PLACEHOLDER": "Nimic"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Date personalizate",
      "ORDER_HISTORY": "Istoric comenzi",
      "CONTACT_DETAILS": "Detalii contact",
      "CONVERSATION_ACTIONS": "Acțiuni de conversație",
      "CONVERSATION_LABELS": "Etichete conversație",
      "CONVERSATION_INFO": "Informații despre conversație",
      "CONTACT_ATTRIBUTES": "Atribute Contacte",
      "PREVIOUS_CONVERSATION": "Conversații anterioare",
      "MACROS": "Macrocomenzi",
      "RETINO_TICKETS": "Tichete Retino",
      "SHOPIFY_ORDERS": "Shopify Orders"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "În aşteptare",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "Nu s-au găsit date",
    "LOAD_ERROR": "Nu s-au putut încărca datele. Vă rugăm să încercați din nou mai târziu."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Încarcă mai multe",
    "NO_RECORDS_FOUND": "Niciun tichet găsit",
    "LOAD_ERROR": "Nu se pot încărca tichetele din {hookName}. Vă rugăm să încercați din nou mai târziu.",
    "NOT_SEARCHABLE": "Emailul contactului nu este setat.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Se încarcă...",
    "NO_ORDERS": "Nicio comandă găsită",
    "NOT_AVAILABLE": "Date despre client indisponibile",
    "EXPAND": "Deschide profilul clientului",
    "MORE_ITEMS": "+ {count} articole",
    "EXPEDITION_STATUS": "Stare expediere",
    "OPEN_DETAIL": "deschide detalii",
    "COPY_ORDER_ID": "Număr comandă",
    "EXTERNAL_ID": "ID extern",
    "PAYMENT_TYPE": "Metodă de plată",
    "PAYMENT_DATE": "Data plății",
    "DELIVERY_PROVIDER": "Curier",
    "EXPECTED_DATE_OF_DELIVERY": "Livrare estimată",
    "DATE_OF_DELIVERY": "Livrat pe",
    "EXPEDITION_DATE": "Data expedierii",
    "INTERNAL_NOTE": "Nota magazinului",
    "PACKAGE_NUMBER": "Colet"
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Creare atribut",
    "NO_RECORDS_FOUND": "Nu s-au găsit atribute",
    "UPDATE": {
      "SUCCESS": "Atribut actualizat cu succes",
      "ERROR": "Imposibil de actualizat atributul. Vă rugăm să încercați din nou mai târziu"
    },
    "ADD": {
      "TITLE": "Adaugă",
      "SUCCESS": "Atribut adăugat cu succes",
      "ERROR": "Imposibil de adăugat atributul. Vă rugăm să încercați din nou mai târziu"
    },
    "DELETE": {
      "SUCCESS": "Atribut sters cu succes",
      "ERROR": "Imposibil de șters atributul. Vă rugăm să încercați din nou mai târziu"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Adaugă atributii",
      "PLACEHOLDER": "Cauta atributii",
      "NO_RESULT": "Nu s-au găsit atributii"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "De la",
    "TO": "Către",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Subiect"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participante",
    "SIDEBAR_TITLE": "Participanți la conversație",
    "NO_RECORDS_FOUND": "Niciun rezultat găsit",
    "ADD_PARTICIPANTS": "Selectarea participanților",
    "REMANING_PARTICIPANTS_TEXT": "+{count} altele",
    "REMANING_PARTICIPANT_TEXT": "+{count} altele",
    "TOTAL_PARTICIPANTS_TEXT": "{count} participă oamenii.",
    "TOTAL_PARTICIPANT_TEXT": "{count} persoană participă.",
    "NO_PARTICIPANTS_TEXT": "Nimeni nu participă!.",
    "WATCH_CONVERSATION": "Începe conversația",
    "YOU_ARE_WATCHING": "Participați",
    "API": {
      "ERROR_MESSAGE": "Nu s-a putut actualiza, încercați din nou!",
      "SUCCESS_MESSAGE": "Participanții au actualizat!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Vizualizarea conținutului tradus",
    "DESC": "Puteți vizualiza conținutul tradus în fiecare langauge.",
    "ORIGINAL_CONTENT": "Conținut original",
    "TRANSLATED_CONTENT": "Conținut tradus",
    "NO_TRANSLATIONS_AVAILABLE": "Nu sunt disponibile traduceri pentru acest conținut"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Cineva scrie"
  },
  "READING": {
    "ONE": "{user} citește acest tichet",
    "TWO": "{user} și {secondUser} citesc acest tichet",
    "MULTIPLE": "{user} și încă {count} utilizatori citesc acest tichet"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Mută conversația",
    "DESCRIPTION": "Mutați această conversație într-un alt inbox de email.",
    "SOURCE": {
      "TITLE": "Conversație",
      "ID_LABEL": "ID conversație"
    },
    "TARGET": {
      "TITLE": "Inbox destinație",
      "PLACEHOLDER": "Selectați un inbox de email",
      "NO_RESULTS": "Niciun alt inbox de email disponibil",
      "ERROR": "Vă rugăm să selectați un inbox destinație"
    },
    "SUBMIT": "Mută conversația",
    "CANCEL": "Anulează",
    "SUCCESS_MESSAGE": "Conversație mutată cu succes",
    "ERROR_MESSAGE": "Nu s-a putut muta conversația. Vă rugăm să încercați din nou."
  },
  "MERGE": {
    "TITLE": "Îmbină conversații",
    "DESCRIPTION": "Îmbinați această conversație cu o altă conversație. Toate mesajele din această conversație vor fi mutate în conversația țintă, iar această conversație va fi ștearsă.",
    "SOURCE": {
      "TITLE": "Conversație sursă (va fi ștearsă)",
      "ID_LABEL": "ID conversație"
    },
    "TARGET": {
      "TITLE": "Conversație țintă",
      "PLACEHOLDER": "Tastați ID-ul conversației pentru căutare (de ex., 123)",
      "HELP": "Introduceți ID-ul conversației în care să fie îmbinate toate mesajele.",
      "ERROR": "Vă rugăm să selectați o conversație țintă"
    },
    "WARNING": "Avertisment: Această acțiune nu poate fi anulată. Toate mesajele vor fi mutate în conversația țintă, iar această conversație va fi ștearsă definitiv.",
    "SUBMIT": "Îmbină conversații",
    "CANCEL": "Anulează",
    "SUCCESS_MESSAGE": "Conversație îmbinată cu succes",
    "ERROR_MESSAGE": "Nu s-au putut îmbina conversațiile. Vă rugăm să verificați conversația țintă și să încercați din nou.",
    "SEARCH": {
      "NO_RESULTS": "Nicio conversație găsită cu acest ID",
      "ERROR_MESSAGE": "Nu s-au putut căuta conversațiile. Vă rugăm să încercați din nou."
    },
    "CONFIRM": {
      "TITLE": "Confirmă îmbinarea",
      "DESCRIPTION": "Sigur doriți să îmbinați această conversație? Această acțiune nu poate fi anulată.",
      "YES": "Da, îmbină",
      "CANCEL": "Anulează"
    }
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  }
}
